import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Stat tile for dashboard rows. */
@Component({
  selector: 'app-stat-tile',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="stat" [attr.data-tone]="tone()">
      <div class="stat__value">{{ value() }}</div>
      <div class="stat__label">{{ label() }}</div>
      @if (sub()) {
        <div class="stat__sub">{{ sub() }}</div>
      }
    </div>
  `,
  styleUrl: './stat-tile.component.scss'
})
export class StatTileComponent {
  readonly value = input.required<string | number>();
  readonly label = input.required<string>();
  readonly sub = input<string>('');
  readonly tone = input<'blue' | 'green' | 'gold' | 'red' | 'neutral'>('blue');
}
